import React, { useState } from "react";
import { arrayOf, shape, string, object, bool } from "prop-types";
import cx from "classnames";

import useClickAway from "../../common/useClickAway.js";
import SlideshowItem from "./SlideshowItem.jsx";
import Icon from "../../components/Icon/Icon.jsx";
import VideoButton from "../../components/VideoButton/VideoButton.jsx";

const propTypes = {
  imageRight: bool,
  items: arrayOf(
    shape({
      title: string,
      description: string,
      video: object,
    }),
  ),
};

const MultiContentSlideshow = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const containerRef = useClickAway({ isOpen, setOpen });

  const { imageRight, items } = props;

  return (
    <section className="multi-content-slideshow component">
      <div
        aria-hidden={!isOpen}
        ref={containerRef}
        className={cx("multi-content-slideshow__video-container", {
          "multi-content-slideshow__video--active": isOpen,
        })}
      >
        {isOpen && (
          <>
            <button
              className="multi-content-slideshow__close-overlay btn"
              onClick={() => setOpen(false)}
              type="button"
            >
              <Icon iconName="close" />
              <span className="u-visuallyhidden">Close video</span>
            </button>
            <iframe
              title="video block"
              src={`https://www.youtube.com/embed/${items[activeIndex].video.id}`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </>
        )}
      </div>

      <div
        className={cx("multi-content-slideshow__inner", {
          "multi-content-slideshow__inner--reverse": imageRight,
        })}
      >
        <div className="multi-content-slideshow__posters-container">
          {items &&
            items.map((item, i) =>
              item.video.id ? (
                <div
                  key={i}
                  className={cx(
                    "multi-content-slideshow__poster-image video-is-paused",
                    {
                      "multi-content-slideshow__poster-image--active":
                        i === activeIndex,
                    },
                  )}
                >
                  <img
                    alt={item.video.poster.alt}
                    srcSet={`${item.video.poster.small} 480w, ${item.video.poster.medium} 680w, ${item.video.poster.large} 1292w`}
                    sizes="(min-width: 781px) 100vw, 0px"
                  />

                  {!isOpen && (
                    <VideoButton
                      onClick={() => setOpen(true)}
                      ariaExpanded={isOpen}
                      isPlaying={isOpen}
                      className="multi-content-slideshow__video-trigger"
                      label="play video"
                    />
                  )}
                </div>
              ) : (
                <div
                  key={i}
                  className={cx("multi-content-slideshow__poster-image", {
                    "multi-content-slideshow__poster-image--active":
                      i === activeIndex,
                  })}
                >
                  <img
                    alt={item.video.poster.alt}
                    srcSet={`${item.video.poster.small} 480w, ${item.video.poster.medium} 680w, ${item.video.poster.large} 1292w`}
                    sizes="(min-width: 781px) 55vw, 0px"
                  />
                </div>
              ),
            )}
        </div>
        <div className="multi-content-slideshow__content">
          {items &&
            items.map((item, i) => (
              <SlideshowItem
                key={i}
                isOpen={i === activeIndex}
                handleItemClick={() => setActiveIndex(i)}
                title={item.title}
                description={item.description}
                video={item.video}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

MultiContentSlideshow.propTypes = propTypes;
export default MultiContentSlideshow;
